<template>
  <div class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>제보 유저 발송 메시지</b>
      </h4>

      <div class="row">
        <div class="col-md-12 checkbox-radios">
          <base-radio
            class="radio-button col-md-12"
            v-for="(message, index) in messages"
            v-bind:name="index"
            v-bind:key="index"
            v-bind:message="message"
            v-model="selectedMessageIndex"
            >{{ message }}</base-radio
          >
          <base-radio name="-1" v-model="selectedMessageIndex">보내지 않음</base-radio>
        </div>
      </div>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";

export default {
  name: "TriviaContentModal",
  components: {
    BaseButton,
    Modal,
  },
  data() {
    return {
      selectedMessageIndex: -1,
    };
  },
  props: {
    shouldShow: {
      type: Boolean,
      required: true,
    },
    messages: {
      type: Array,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onClickConfirm: async function () {
      await this.onConfirm(this.messages[this.selectedMessageIndex]);
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
  },
};
</script>
<style lang="scss">
.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
